import { writable } from "svelte/store";
import { watchEvents } from "@/function/sseEvents.js";

const defaultConfig = {
  states: {
    payment: null,
    initialize: null,
    charge: null,
    error: false,
    message: "",
    messages: [],
    closeModal: false,
  },
};

const getDefaultState = () => {
  return JSON.parse(JSON.stringify(defaultConfig.states));
};

/*
 *  https://alvarotrigo.com/blog/progress-bar-css/
 */
const updateStatus = (icon, status) => {
  let stepCircles = false;

  if (icon && icon !== "error") {
    stepCircles = document.querySelectorAll(
      `.container > .progress-container > .circle.${icon}`
    );
  } else if (icon === "error") {
    stepCircles = document.querySelectorAll(
      `.container > .progress-container > .circle`
    );
    stepCircles.forEach((circle) => {
      circle.classList.add("error");
    });
  }

  if (stepCircles && status) {
    stepCircles[0].classList.add("success");
  } else {
    const showError = document.querySelectorAll(`.container > .error`);
    showError[0].style.display = "block";
    if (stepCircles) stepCircles[0].classList.add("error");
  }
};

export const statusState = (function () {
  let currentState = getDefaultState();
  const store = writable(
    (() => {
      return getDefaultState();
    })()
  );

  const { subscribe, set: masterSet } = store;

  const set = (value) => {
    currentState = { ...currentState, ...value }; // Don't erase previously set values
    masterSet({ ...getDefaultState(), ...currentState }); // set store
  };

  const setErrorResponseStatus = (res) => {
    updateStatus(res.type, res.success);
    currentState.messages.push(res.message);
    set({
      error: true,
      message: res.message,
      messages: currentState.messages,
    });
  };

  // What updates the store
  const setResponseStatus = (res) => {
    updateStatus(res.type, res.success);
    currentState.messages.push(res.message);
    if (res.type === "charge" && res.success) {
      console.log("[*] Charge success!!!");
      currentState.closeModal = true;
    }
    set({
      [res.type]: res.success,
      message: res.message,
      messages: currentState.messages,
      closeModal: currentState.closeModal,
    });
  };

  return {
    set,
    subscribe,
    resetStatus: () => {
      set(getDefaultState());
    },
    // Setup event watcher
    watchEvent: (eventId) => {
      watchEvents(eventId);
    },
    // Parse events from watcher
    showError: (err) => {
      updateStatus(false, false);
      set({ error: true, message: err });
    },
    // Called by ssEvents.js
    // setResponseStatus is what updates the store
    updateStatus: (res) => {
      console.log("[*] Response:", res);
      switch (res?.type) {
        case "payment":
        case "initialize":
        case "charge":
          setResponseStatus(res);
          return;
        case "error":
          setErrorResponseStatus(res);
          return;
      }

      set({ error: true, message: "Unknown error!" });
    },
  };
})();

export const userState = (function () {
  const { subscribe, set } = writable(
    (() => {
      const jsonAuth = localStorage.getItem("auth") || false;
      if (jsonAuth) {
        return JSON.parse(jsonAuth).token;
      }
    })()
  );

  return {
    subscribe,
    getUserProfile: () => {
      const auth = JSON.parse(localStorage.getItem("auth"));
      if (auth && "profile" in auth) {
        return auth.profile;
      }

      return false;
    },
    signout: () => {
      localStorage.removeItem("auth");
      set(null);

      window.location.replace("/login");
    },
    updateJWT: (token) => {
      const authJson = localStorage.getItem("auth");

      if (authJson) {
        const auth = JSON.parse(authJson);
        localStorage.setItem("auth", JSON.stringify({ ...auth, token }));
      }

      updateAuthHeader();
      set(token);
    },
    signin: (token, refreshToken, username) => {
      localStorage.setItem(
        "auth",
        JSON.stringify({ token, profile: { username } })
      );
      localStorage.setItem("refresh", refreshToken);
      set(token);

      /*
      setTimeout(() => {
        window.location.replace('/')
      }, 500)
      */
    },
  };
})();
